var _rect, _circle, _path, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryPay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.30542,
    y: 0.358032,
    width: 22,
    height: 14.1893,
    rx: 4,
    fill: "#757A88"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.3054,
    cy: 7.4527,
    r: 3.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5819 6.13434H11.7284C12.0188 6.13434 12.2538 6.22288 12.4335 6.39996C12.6145 6.57705 12.705 6.81012 12.705 7.09918C12.705 7.38694 12.6119 7.62002 12.4257 7.7984C12.2395 7.97548 11.9973 8.06403 11.6991 8.06403H11.1718V8.9527H10.5819V6.13434ZM11.1718 6.60114V7.60309H11.5702C11.7395 7.60309 11.871 7.55947 11.9647 7.47223C12.0585 7.38499 12.1053 7.26129 12.1053 7.10114C12.1053 6.94098 12.0585 6.81793 11.9647 6.73199C11.8723 6.64476 11.7414 6.60114 11.5721 6.60114H11.1718Z",
    fill: "#757A88"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.98785,
    cy: 7.4527,
    r: 1,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.1714,
    cy: 7.4527,
    r: 1,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryPay);
export default __webpack_public_path__ + "static/media/history_pay.7d44a9b9263ce495cab22216e04c1e60.svg";
export { ForwardRef as ReactComponent };